import React from "react";
import "../skills.css";

const skills = [
  {
    name: "HTML",
    description:
      "I use HTML to build structured and accessible web pages. It forms the backbone of all my web projects.",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg",
  },
  {
    name: "CSS",
    description:
      "With CSS, I style beautiful and responsive layouts. I enjoy crafting clean and modern UI designs.",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg",
  },
  {
    name: "JavaScript",
    description:
      "I use JavaScript to bring life to web pages by adding interactivity, animations, and dynamic functionality.",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
  },
  {
    name: "React",
    description:
      "React allows me to build modern, component-based SPAs. I enjoy its power and flexibility in front-end development.",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
  },
  {
    name: "Java (Basics)",
    description:
      "I’ve learned the basics of Java and can write object-oriented code to solve logical problems.",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg",
  },
 
  {
    name: "Node.js",
    description:
      "I use Node.js to build scalable backend servers and APIs. It allows me to write JavaScript on the server side.",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg",
  },
  {
    name: "Express.js",
    description:
      "With Express, I create RESTful APIs efficiently. It simplifies routing, middleware, and server-side logic.",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg",
  },
  {
    name: "MongoDB",
    description:
      "I use MongoDB for NoSQL database needs. Its flexibility and JSON-like documents make it great for modern apps.",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg",
  },
  {
    name: "Java (Basics)",
    description:
      "I’ve learned the basics of Java and can write object-oriented code to solve logical problems.",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg",
  },

];

function Skills() {
  return (
    <section id="skills" className="skills-section">
      <h2 className="skills-title">MY SKILLS</h2>
      <div className="skills-grid">
        {skills.map((skill, index) => (
          <div className="skill-card" key={index}>
            <img src={skill.icon} alt={`${skill.name} logo`} className="skill-icon" />
            <div className="skill-info">
              <h3>{skill.name}</h3>
              <p>{skill.description}</p>
            </div>
          </div>
        ))}
      </div>
      <br /><br /><hr />
    </section>
  );
}

export default Skills;
